/** familyPage strings for pa, te, ta, mr, bn, kn */

export const FAMILY_PAGE_LOCALES = {
  pa: {
    title: "ਪਰਿਵਾਰ ਮੈਂਬਰ",
    myFamily: "ਮੇਰੇ ਪਰਿਵਾਰ ਮੈਂਬਰ",
    searchPlaceholder: "ਨਾਮ ਨਾਲ ਖੋਜੋ",
    name: "ਨਾਮ",
    patientId: "ਮਰੀਜ਼ ID",
    memberId: "ਮੈਂਬਰ ID",
    relation: "ਰਿਸ਼ਤਾ",
    dob: "ਜਨਮ ਤਾਰੀਖ",
    gender: "ਲਿੰਗ",
    bloodGroup: "ਬਲੱਡ ਗਰੁੱਪ",
    phone: "ਫੋਨ",
    status: "ਸਥਿਤੀ",
    action: "ਕਾਰਵਾਈ",
    pending: "ਲੰਬਿਤ",
    active: "ਸਕ੍ਰਿਆ",
    inactive: "ਨਿਸ਼ਕ੍ਰਿਆ",
    questionnairePending: "ਪ੍ਰਸ਼ਨਾਵਲੀ ਲੰਬਿਤ",
    total: "ਕੁੱਲ",
    noData: "ਕੋਈ ਡੇਟਾ ਨਹੀਂ",
    addMember: "ਮੈਂਬਰ ਜੋੜੋ",
    addFamilyMember: "ਪਰਿਵਾਰ ਮੈਂਬਰ ਜੋੜੋ",
  },
  te: {
    title: "కుటుంబ సభ్యులు",
    myFamily: "నా కుటుంబ సభ్యులు",
    searchPlaceholder: "పేరుతో వెతకండి",
    name: "పేరు",
    patientId: "రోగి ID",
    memberId: "సభ్యుని ID",
    relation: "సంబంధం",
    dob: "పుట్టిన తేదీ",
    gender: "లింగం",
    bloodGroup: "రక్త గ్రూప్",
    phone: "ఫోన్",
    status: "స్థితి",
    action: "చర్య",
    pending: "పెండింగ్",
    active: "సక్రియ",
    inactive: "నిష్క్రియ",
    questionnairePending: "ప్రశ్నావధి పెండింగ్",
    total: "మొత్తం",
    noData: "డేటా లేదు",
    addMember: "సభ్యుడిని జోడించండి",
    addFamilyMember: "కుటుంబ సభ్యుడిని జోడించండి",
  },
  ta: {
    title: "குடும்ப உறுப்பினர்கள்",
    myFamily: "எனது குடும்ப உறுப்பினர்கள்",
    searchPlaceholder: "பெயரால் தேடு",
    name: "பெயர்",
    patientId: "நோயாளி ID",
    memberId: "உறுப்பினர் ID",
    relation: "உறவு",
    dob: "பிறந்த தேதி",
    gender: "பாலினம்",
    bloodGroup: "இரத்த வகை",
    phone: "தொலைபேசி",
    status: "நிலை",
    action: "செயல்",
    pending: "நிலுவையில்",
    active: "செயலில்",
    inactive: "செயலற்ற",
    questionnairePending: "கேள்வித்தாள் நிலுவை",
    total: "மொத்தம்",
    noData: "தரவு இல்லை",
    addMember: "உறுப்பினரைச் சேர்",
    addFamilyMember: "குடும்ப உறுப்பினரைச் சேர்",
  },
  mr: {
    title: "कुटुंब सदस्य",
    myFamily: "माझे कुटुंब सदस्य",
    searchPlaceholder: "नावाने शोधा",
    name: "नाव",
    patientId: "रुग्ण ID",
    memberId: "सदस्य ID",
    relation: "नाते",
    dob: "जन्मतारीख",
    gender: "लिंग",
    bloodGroup: "रक्तगट",
    phone: "फोन",
    status: "स्थिती",
    action: "कृती",
    pending: "प्रलंबित",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    questionnairePending: "प्रश्नावली प्रलंबित",
    total: "एकूण",
    noData: "डेटा नाही",
    addMember: "सदस्य जोडा",
    addFamilyMember: "कुटुंब सदस्य जोडा",
  },
  bn: {
    title: "পরিবারের সদস্য",
    myFamily: "আমার পরিবার সদস্য",
    searchPlaceholder: "নামে খুঁজুন",
    name: "নাম",
    patientId: "রোগী ID",
    memberId: "সদস্য ID",
    relation: "সম্পর্ক",
    dob: "জন্ম তারিখ",
    gender: "লিঙ্গ",
    bloodGroup: "রক্তের গ্রুপ",
    phone: "ফোন",
    status: "অবস্থা",
    action: "কর্ম",
    pending: "মুলতুবি",
    active: "সক্রিয়",
    inactive: "নিষ্ক্রিয়",
    questionnairePending: "প্রশ্নাবলী মুলতুবি",
    total: "মোট",
    noData: "কোনো ডেটা নেই",
    addMember: "সদস্য যোগ করুন",
    addFamilyMember: "পরিবার সদস্য যোগ করুন",
  },
  kn: {
    title: "ಕುಟುಂಬ ಸದಸ್ಯರು",
    myFamily: "ನನ್ನ ಕುಟುಂಬ ಸದಸ್ಯರು",
    searchPlaceholder: "ಹೆಸರಿನಿಂದ ಹುಡುಕಿ",
    name: "ಹೆಸರು",
    patientId: "ರೋಗಿ ID",
    memberId: "ಸದಸ್ಯ ID",
    relation: "ಸಂಬಂಧ",
    dob: "ಜನ್ಮ ದಿನಾಂಕ",
    gender: "ಲಿಂಗ",
    bloodGroup: "ರಕ್ತ ಗುಂಪು",
    phone: "ಫೋನ್",
    status: "ಸ್ಥಿತಿ",
    action: "ಕ್ರಿಯೆ",
    pending: "ಬಾಕಿ",
    active: "ಸಕ್ರಿಯ",
    inactive: "ನಿಷ್ಕ್ರಿಯ",
    questionnairePending: "ಪ್ರಶ್ನಾವಳಿ ಬಾಕಿ",
    total: "ಒಟ್ಟು",
    noData: "ಡೇಟಾ ಇಲ್ಲ",
    addMember: "ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
    addFamilyMember: "ಕುಟುಂಬ ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿ",
  },
};

export const applyFamilyPageLocales = (translations) => {
  Object.entries(FAMILY_PAGE_LOCALES).forEach(([lang, familyPage]) => {
    if (!translations[lang]) return;
    translations[lang].familyPage = {
      ...translations[lang].familyPage,
      ...familyPage,
    };
  });
};
